import { lang } from '@lang/interfaces/lang';
import { IBrand, IBrandLogo } from './interfaces/IBrand';

// Подставляется DefinePlugin из brands/<BRAND>/brand.config.js.
declare const __BRAND__: IBrand;

export const brandConfig: IBrand = __BRAND__;

export const brandLogoSrc = (logo: IBrandLogo, currentLang: lang): string =>
    `public/img/svg/${logo.localized && currentLang === 'en' ? 'en_' : ''}${
        logo.file
    }`;
